import { useTheme } from '@/app/providers';
import { cn } from '@/shared/cn';
import { useBrand } from '../BrandContext';

/**
 * The selected brand's logo on its own — no AiRis wordmark, no "for". The
 * letterhead, the deck cover and the mail signature all print the OEM's mark,
 * not the product's, so they cannot use `BrandMark`'s lockup.
 *
 * `reversed` forces the light-on-dark file for surfaces that are dark in both
 * themes (the deck cover); otherwise the file follows the theme.
 */
export function OemLogo({
  height,
  reversed,
  className,
}: {
  height: number;
  reversed?: boolean;
  className?: string;
}) {
  const { brand } = useBrand();
  const { theme } = useTheme();
  const src = reversed || theme === 'dark' ? brand.logoReversed : brand.logo;
  return (
    <img
      src={src}
      alt={brand.client}
      title={brand.client}
      height={height}
      style={{ height, width: 'auto' }}
      className={cn('block flex-shrink-0', className)}
    />
  );
}
